export default __webpack_public_path__ + "static/inline-dialog.light-f5df8b43fbe562d62999609ebc6e8a0d78320f458bfa4f36a19f95ed53ea47da.png";